import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
import fonts from 'constants/fonts';
import { CAPTCHA_HEADER_TXT, CAPTCHA_MESSAGE_TXT } from '../../helper/perimeterX';

const useStyles = makeStyles(() => ({
	captchaContent: {
		margin: '30px auto'
	},
	pxCaptcha: {
		marginLeft: 'calc(50% - 80px)'
	},
	infoText: {
		fontFamily: fonts.BOGLE_REGULAR,
		fontSize: 18,
		color: colors.DARK_CHARCOAL,
		textAlign: 'center',
		marginBottom: 15
	}
}));

const PerimeterXCaptcha = ({ secondaryTextMsg = '' }) => {
	const styles = useStyles();

	return (
		<div className={styles.captchaContent}>
			<p className={styles.infoText}>{CAPTCHA_HEADER_TXT}</p>
			<p className={styles.infoText}>{CAPTCHA_MESSAGE_TXT}</p>
			<div className={styles.pxCaptcha} id="px-captcha"></div>
			<p className={styles.infoText}>{secondaryTextMsg}</p>
		</div>
	);
};

export default PerimeterXCaptcha;
